module.exports = __webpack_public_path__ + "img/intro_video_text_top.9cdc6825.png";